document.addEventListener('DOMContentLoaded', function () {
    const url = window.location.href;
    const match = url.match(/\/ka\/innovations\/(\d+)/);

    if (match) {
      const qrCode = match[1];

      // Inject styles for loading screen
      const style = document.createElement('style');
      style.textContent = `
  #loading-screen {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 70px;
    z-index: 9999;
    transition: opacity 0.5s ease;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  #loading-spinner {
    animation: spin 1.2s linear infinite;
    width: 80px;
    height: 80px;
  }
`;

      document.head.appendChild(style);

      // Inject loading screen HTML
      const loadingScreen = document.createElement('div');
      loadingScreen.id = 'loading-screen';
      loadingScreen.innerHTML = `
        <svg id="loading-spinner" viewBox="0 0 50 50">
          <circle
            cx="25" cy="25" r="20"
            fill="none"
            stroke="#555"
            stroke-width="5"
            stroke-linecap="round"
            stroke-dasharray="31.4 31.4"
            transform="rotate(-90 25 25)">
          </circle>
        </svg>
      `;
      document.body.appendChild(loadingScreen);

       // Redirect after 100ms delay
      setTimeout(() => {
        window.location.href = `https://webdropper.meama.ge/?qrCode=${qrCode}`;
      }, 150);
    }
  });